export const FLOWER_BOX_BUYING_GUIDE = {
  id: 'flower-boxy',
  eyebrow: 'Wybór kwiatów w pudełku',
  sections: [
    {
      heading: 'Kwiaty w pudełku - kiedy wybrać flower box?',
      paragraphs: [
        {
          text: 'Flower box łączy kompozycję kwiatową z dekoracyjnym pudełkiem. Oba elementy tworzą prezent, dlatego podczas oglądania zdjęć zwróć uwagę także na oprawę: jej kolor, fakturę i proporcje względem kwiatów. Taka forma sprawdzi się, gdy chcesz podarować przemyślaną całość, dopasowaną do upodobań bliskiej osoby. Możesz wybrać spokojną kompozycję do jasnego wnętrza albo wyraziste zestawienie, w którym pudełko dodatkowo podkreśla barwy kwiatów.',
        },
        {
          text: 'Jeżeli odbiorca lubi samodzielnie układać łodygi w ulubionym wazonie, porównaj również bukiety. Flower box warto wybrać wtedy, gdy zależy Ci na kompozycji, której pudełko jest częścią dekoracji. Przy planowaniu prezentu uwzględnij miejsce, w którym ma stanąć, oraz sposób jego wręczenia.',
          links: [{ text: 'bukiety', href: '/bukiety/' }],
        },
      ],
    },
    {
      heading: 'Kolor, kształt i rozmiar pudełka',
      paragraphs: [
        {
          text: 'Oceniaj pudełko razem z kwiatami. Niska, szeroka forma daje inny efekt niż kompozycja mocniej rozbudowana w górę. Zdjęcie pozwala porównać te proporcje, ale nie zastępuje wymiarów. Jeśli planujesz ustawienie prezentu na konkretnej półce lub stoliku, a w opisie brakuje wymiarów, zapytaj o nie przed zakupem.',
        },
      ],
      subsections: [
        {
          heading: 'Stonowane kompozycje i mocniejsze kolory',
          paragraphs: [
            {
              text: 'Wolisz łagodny efekt? Pastelowe Love zestawia róż, biel, krem i zieleń. To punkt wyjścia dla osoby, która szuka jasnej, delikatnej kompozycji. Czerwony Skarb Miłości łączy czerwone róże i goździki z eukaliptusem oraz czerwonym pudełkiem. Spodoba się komuś, kto lubi zdecydowaną kolorystykę. W Pudełku Miłości oprawą jest bordowe, welurowe pudełko. Porównując te propozycje, pomyśl, czy prezent ma pasować do ulubionych barw odbiorcy, czy stać się mocniejszym akcentem w jego otoczeniu.',
            },
          ],
        },
        {
          heading: 'Sprawdź zawartość wybranego wariantu',
          paragraphs: [
            {
              text: 'Rozmiar wybieraj na karcie konkretnego flower boxa. W części ofert dostępne są warianty Mały, Średni, Duży i Premium, a ich opis może wskazywać liczbę kwiatów oraz dodatki. Porównaj te informacje z ceną wybranej opcji. Nazwa rozmiaru sama w sobie nie określa wymiarów pudełka i nie oznacza identycznej zawartości w różnych kompozycjach. Gdy w opisie wariantu nie ma szczegółowego składu, dopytaj o niego, zwłaszcza jeśli zależy Ci na konkretnym gatunku lub liczbie kwiatów.',
            },
          ],
        },
      ],
    },
    {
      heading: 'Flower box na urodziny lub romantyczny prezent',
      paragraphs: [
        {
          text: 'Na urodzinowe spotkanie wybierz box, który kojarzy Ci się z solenizantem: subtelny, kolorowy albo oparty na jego ulubionych kwiatach. Jeśli rozważasz kilka form prezentu, zobacz kwiaty na urodziny i porównaj pudełka z innymi kompozycjami. Urodzinowy charakter możesz nadać upominkowi także krótką wiadomością na bileciku, nawiązującą do Waszych wspólnych wspomnień.',
          links: [{ text: 'kwiaty na urodziny', href: '/okazje/urodziny/' }],
        },
        {
          text: 'Na rocznicę lub romantyczną niespodziankę możesz sięgnąć po czerwienie albo wybrać mniej oczywistą kolorystykę, którą lubi bliska osoba. Najważniejsze, by prezent pasował do Waszej relacji. Szukając kwiatów dla mamy, pomyśl z kolei o kompozycji w jej ulubionym stylu. Delikatny flower box może być podziękowaniem, a intensywne barwy dobrym wyborem dla mamy, która chętnie otacza się kolorem.',
          links: [{ text: 'kwiatów dla mamy', href: '/dla-kogo/mamy/' }],
        },
      ],
    },
    {
      heading: 'Dostawa flower boxa i pielęgnacja po odbiorze',
      paragraphs: [
        {
          text: 'Flower box możesz zamówić z dostawą w Lublinie i okolicach. Przed opłaceniem prezentu sprawdź termin oraz koszt dla adresu odbiorcy. Informacje o dostawie kwiatów pomogą Ci przygotować dane do doręczenia i ustalić, co zrobić, gdy obdarowanej osoby nie będzie na miejscu.',
          links: [{ text: 'Informacje o dostawie kwiatów', href: '/dostawa/' }],
        },
        {
          text: 'Przy odbiorze zapytaj o pielęgnację wybranego flower boxa. Poproś o wskazówki dotyczące miejsca ustawienia oraz tego, czy i jak uzupełniać wodę w tej konkretnej kompozycji. Sposób postępowania dopasuj do jej wykonania. Jeśli zamawiasz kwiaty dla kogoś, przekaż odbiorcy uzyskane zalecenia, aby wiedział, jak zadbać o prezent.',
        },
      ],
    },
  ],
} as const;
